import classes from "./CommentField.module.css";
import util from "../../styles/utilities.module.css";
import ReactDOM from "react-dom";
const CommentField = ({
  valueHandler,
  comment,
  saveHandler,
  cancelHandler,
  placeholder,
}) => {
  return ReactDOM.createPortal(
    <div className={`${classes["modal-overlay"]} ${util.modalOverlay}`}>
      <div className={`${classes.modal} ${util.surface}`}>
        <div className={classes.commentBox}>
          <input
            placeholder={placeholder}
            onChange={(e) => valueHandler(e.target.value)}
            value={comment}
            className={classes.inputBox}
          />
          <div className={classes.saveCancelContainer}>
            <button onClick={cancelHandler} className={`${util.btn} ${util['btn-sm']} ${util['btn--ghost']}`}>
              Cancel
            </button>
            <button onClick={saveHandler} className={`${util.btn} ${util['btn-sm']}`}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CommentField;
